import { PlanCategory } from '@/shared/types/Billing';

// What the paywall offers a plan without on-screen text translation: plans below Business upgrade to it, while Business
// and Enterprise plans get it as a paid add-on through sales.
export type OnscreenOffer = 'addOn' | 'upgrade';

type GetOnscreenOfferParams = {
  hasEnterprisePlan: boolean;
  planCategory?: PlanCategory;
};

export const getOnscreenOffer = ({ hasEnterprisePlan, planCategory }: GetOnscreenOfferParams): OnscreenOffer =>
  hasEnterprisePlan || planCategory === PlanCategory.Business || planCategory === PlanCategory.Enterprise
    ? 'addOn'
    : 'upgrade';
